var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-content',[_c('b-row',[_c('b-col',[_c('h5',[_vm._v("162")]),_c('iframe',{attrs:{"id":"jupyter","width":"600","height":"400","src":"./html/162.html","frameborder":"1"}})]),_c('b-col',[_c('h5',[_vm._v("165")]),_c('iframe',{attrs:{"id":"jupyter","width":"600","height":"400","src":"./html/165.html","frameborder":"1"}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }